import { render, staticRenderFns } from "./cursos-detalles-resumen.vue?vue&type=template&id=630be0f5&scoped=true&"
import script from "./cursos-detalles-resumen.vue?vue&type=script&lang=ts&"
export * from "./cursos-detalles-resumen.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-detalles-resumen.vue?vue&type=style&index=0&id=630be0f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630be0f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
